import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {


    editBackOrder (orderLineId) {
        return axios.post('/api/backOrders/editBackOrder', { orderLineId: orderLineId } )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getBackOrders (page, pageSize, refFilter,customerId) {
        return axios.get('/api/backOrders/list', { params: { page: page, pageSize: pageSize, filter:refFilter, customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    cancelBackOrder (id) {
        return axios.post('/api/backOrders/cancelBackOrder', { id: id } )
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success(i18n.t('services.orders.cancelBackorder'));
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveBackOrderQuantity (id,quantity) {
        return axios.post('/api/backOrders/saveBackOrderQuantity', { id: id, quantity:quantity } )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    convertToOrder (selectedBackOrders) {
        return axios.post('/api/backOrders/convertToOrder', {list : selectedBackOrders}  )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getBackOrdersCount(){
        return axios.get('/api/backOrders/count/')
        .then(response => {
            if (response && response.data)  return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}

